/* ============================================================
   Redi Food — Área privada del cliente
   Vanilla, sin dependencias. Cuatro trabajos:
     1. Repetir un kit → /cart/add.js con las MISMAS propiedades del pedido.
     2. Kits guardados (localStorage de este navegador).
     3. Enlace de invitación (copiar / WhatsApp).
     4. Racha y ahorro, calculados con los pedidos que inyecta el Liquid.
   Emite los eventos `flamel:*` que ya consume assets/flamel-cro-events.js.
   ============================================================ */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-rf-cuenta]');
  if (!raiz) return;
  var D = window.RF_CUENTA || {};

  function $(sel, ctx) { return (ctx || raiz).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || raiz).querySelectorAll(sel)); }

  function evento(nombre, datos) {
    try { window.dispatchEvent(new CustomEvent('flamel:cuenta:' + nombre, { detail: datos || {} })); } catch (e) {}
  }

  function pesos(n) {
    // COP sin decimales y con punto de miles, como el resto de la tienda.
    return '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  /* ---------- Aviso en vivo ---------- */
  var flash = $('[data-rf-flash]');
  var flashTimer = null;
  function aviso(texto, tipo) {
    if (!flash) return;
    flash.textContent = texto;
    flash.className = 'rf-mc__flash rf-mc__flash--' + (tipo || 'ok') + ' is-on';
    flash.scrollIntoView({ behavior: 'smooth', block: 'center' });
    clearTimeout(flashTimer);
    if (tipo !== 'err') flashTimer = setTimeout(function () { flash.classList.remove('is-on'); }, 8000);
  }

  /* ============================================================
     1. REPETIR UN KIT
     El pedido ya guarda todo lo que hace falta: la variante del kit,
     los "Almuerzo N" legibles y el `_kit_components` oculto que consume
     el webhook de inventario. Así que aquí NO se reconstruye nada: se
     reenvía el mismo payload que emitió el wizard el día de la compra.
     Un permalink de carrito no sirve — esta tienda devuelve 422 en
     cuanto lleva properties (verificado 2026-08-05).
     ============================================================ */
  function pedirAlCarrito(items, boton) {
    boton.classList.add('is-busy');
    boton.disabled = true;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      // `sections` devuelve de paso el HTML ya actualizado del contador del header.
      body: JSON.stringify({ items: items, sections: 'cart-icon-bubble' })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, cuerpo: j }; });
    }).then(function (res) {
      if (!res.ok) {
        var msg = (res.cuerpo && (res.cuerpo.description || res.cuerpo.message)) || 'No se pudo añadir al carrito.';
        throw new Error(msg);
      }
      refrescarContador(res.cuerpo.sections);
      return res.cuerpo;
    }).finally(function () {
      boton.classList.remove('is-busy');
      boton.disabled = false;
    });
  }

  function refrescarContador(sections) {
    // El header de este theme lleva su PROPIO contador inline (no usa el snippet
    // de Dawn), así que se sustituye el nodo entero por el HTML que devuelve Shopify.
    if (!sections || !sections['cart-icon-bubble']) return;
    var destino = document.getElementById('cart-icon-bubble');
    if (!destino) return;
    try {
      var tmp = document.createElement('div');
      tmp.innerHTML = sections['cart-icon-bubble'];
      var nuevo = tmp.querySelector('#cart-icon-bubble') || tmp.querySelector('.shopify-section');
      if (nuevo) destino.innerHTML = nuevo.innerHTML;
    } catch (e) {}
  }

  function itemsDePedido(id) {
    var nodo = document.querySelector('script[type="application/json"][data-rf-kit="' + id + '"]');
    if (!nodo) return null;
    try { return JSON.parse(nodo.textContent); } catch (e) { return null; }
  }

  $$('[data-rf-repetir]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var items = itemsDePedido(btn.getAttribute('data-rf-repetir'));
      if (!items || !items.length) { aviso('No pudimos leer los platos de ese pedido.', 'err'); return; }
      evento('repetir', { lineas: items.length });
      pedirAlCarrito(items, btn).then(function () {
        aviso('Listo: añadimos los productos al carrito con los mismos platos.', 'ok');
        var ir = $('[data-rf-ir-carrito]');
        if (ir) ir.hidden = false;
      }).catch(function (e) {
        // Se avisa SIEMPRE: un fallo mudo aquí deja al cliente creyendo que compró.
        aviso('No se pudo añadir: ' + e.message + ' Prueba a armarlo desde el armador.', 'err');
      });
    });
  });

  /* Editar los platos: es un <a> de verdad, la navegacion la hace el navegador.
     Aqui solo se emite el evento. dispatchEvent es sincrono, asi que sale antes
     de que la pagina se vaya; nada de preventDefault. */
  raiz.addEventListener("click", function (ev) {
    var a = ev.target.closest("[data-rf-editar]");
    if (!a) return;
    evento("editar_platos", {
      origen: a.getAttribute("data-rf-editar"),
      kit: a.getAttribute("data-rf-editar-kit") || ""
    });
  });

  /* ============================================================
     2. KITS GUARDADOS
     localStorage a propósito: escribir metafields de cliente desde el
     escaparate exige una app. Se dice en pantalla que viven en este
     dispositivo, en vez de fingir que están en la cuenta.
     ============================================================ */
  var CLAVE = 'rf_kits_guardados_v1';
  function leerKits() {
    try { return JSON.parse(localStorage.getItem(CLAVE) || '[]'); } catch (e) { return []; }
  }
  function escribirKits(lista) {
    try { localStorage.setItem(CLAVE, JSON.stringify(lista.slice(0, 20))); } catch (e) {}
  }

  function pintarKits() {
    var cont = $('[data-rf-kits]');
    if (!cont) return;
    var lista = leerKits();
    var vacio = $('[data-rf-kits-vacio]');
    if (vacio) vacio.hidden = lista.length > 0;
    cont.innerHTML = '';
    lista.forEach(function (k, i) {
      var art = document.createElement('div');
      art.className = 'rf-mc__card';
      art.innerHTML =
        '<div class="rf-mc__pedido-top">' +
          '<div style="flex:1;min-width:0">' +
            '<div class="rf-mc__pedido-tit"></div>' +
            '<div class="rf-mc__pedido-meta"></div>' +
          '</div>' +
          '<button class="rf-mc__link" data-borrar="' + i + '">Quitar</button>' +
        '</div>' +
        '<div class="rf-mc__resumen"></div>' +
        '<div style="margin-top:12px"><button class="rf-mc__btn rf-mc__btn--sm" data-pedir="' + i + '">Pedir este kit</button></div>';
      art.querySelector('.rf-mc__pedido-tit').textContent = k.nombre;
      art.querySelector('.rf-mc__pedido-meta').textContent = k.kit + ' · ' + pesos(k.total || 0);
      art.querySelector('.rf-mc__resumen').textContent = k.resumen || '';
      cont.appendChild(art);
    });
  }

  raiz.addEventListener('click', function (ev) {
    var g = ev.target.closest('[data-rf-guardar]');
    if (g) {
      var items = itemsDePedido(g.getAttribute('data-rf-guardar'));
      if (!items) { aviso('No pudimos leer ese kit.', 'err'); return; }
      var nombre = window.prompt('¿Cómo quieres llamar a este kit?', g.getAttribute('data-rf-nombre') || 'Mi kit');
      if (!nombre) return;
      var lista = leerKits();
      lista.unshift({
        nombre: nombre.slice(0, 60),
        kit: g.getAttribute('data-rf-nombre') || '',
        total: Number(g.getAttribute('data-rf-total') || 0),
        resumen: g.getAttribute('data-rf-resumen') || '',
        items: items
      });
      escribirKits(lista);
      pintarKits();
      evento('guardar_kit', {});
      aviso('Guardado. Lo tienes en «Mis kits guardados».', 'ok');
      return;
    }
    var b = ev.target.closest('[data-borrar]');
    if (b) {
      var lista2 = leerKits();
      lista2.splice(Number(b.getAttribute('data-borrar')), 1);
      escribirKits(lista2);
      pintarKits();
      return;
    }
    var p = ev.target.closest('[data-pedir]');
    if (p) {
      var k = leerKits()[Number(p.getAttribute('data-pedir'))];
      if (!k) return;
      evento('repetir_guardado', {});
      pedirAlCarrito(k.items, p)
        .then(function () { aviso('Listo: «' + k.nombre + '» está en el carrito.', 'ok'); })
        .catch(function (e) { aviso('No se pudo añadir: ' + e.message, 'err'); });
    }
  });

  pintarKits();

  /* ============================================================
     3. INVITAR
     ============================================================ */
  var copiar = $('[data-rf-copiar]');
  if (copiar) {
    copiar.addEventListener('click', function () {
      var url = copiar.getAttribute('data-rf-copiar');
      var hecho = function () { aviso('Enlace copiado. Ya puedes pegarlo donde quieras.', 'ok'); evento('copiar_ref', {}); };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(hecho, function () { aviso('No se pudo copiar. Selecciónalo a mano.', 'err'); });
      } else {
        // Safari viejo y contextos sin permiso de portapapeles.
        var ta = document.createElement('textarea');
        ta.value = url; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select();
        try { document.execCommand('copy'); hecho(); } catch (e) { aviso('No se pudo copiar. Selecciónalo a mano.', 'err'); }
        document.body.removeChild(ta);
      }
    });
  }

  /* ============================================================
     4. RACHA Y AHORRO
     Se calcula aquí y no en Liquid porque la aritmética de semanas
     consecutivas en Liquid sale ilegible y frágil. Los datos los
     inyecta el servidor en window.RF_CUENTA.
     ============================================================ */
  function semanaDe(ts) {
    // Índice de semana (lunes) desde epoch. Sirve para agrupar y comparar.
    return Math.floor((Number(ts) + 345600) / 604800); // +4 días: epoch cayó en jueves
  }

  function calcular() {
    var pedidos = (D.pedidos || []).slice().sort(function (a, b) { return b.ts - a.ts; });
    if (!pedidos.length) return null;

    var semanas = {};
    var unidades = 0, gastado = 0;
    pedidos.forEach(function (p) {
      semanas[semanaDe(p.ts)] = true;
      unidades += Number(p.unidades || 0);
      gastado += Number(p.total || 0);
    });

    // Racha = semanas consecutivas hacia atrás desde la última con pedido.
    var claves = Object.keys(semanas).map(Number).sort(function (a, b) { return b - a; });
    var racha = 0, cursor = claves[0];
    // Si la última compra es de hace más de 2 semanas, la racha está rota.
    var ahora = semanaDe(Math.floor(Date.now() / 1000));
    if (ahora - cursor <= 2) {
      while (semanas[cursor]) { racha++; cursor--; }
    }
    // Récord: la racha más larga del histórico.
    var record = 0, corrida = 0, prev = null;
    claves.slice().sort(function (a, b) { return a - b; }).forEach(function (s) {
      corrida = (prev !== null && s === prev + 1) ? corrida + 1 : 1;
      if (corrida > record) record = corrida;
      prev = s;
    });

    var fuera = Number(D.precioFuera || 0);
    var medio = unidades ? gastado / unidades : 0;
    var ahorroUnidad = Math.max(0, fuera - medio);
    return {
      racha: racha, record: record, unidades: unidades, gastado: gastado,
      medio: medio, fuera: fuera, ahorroUnidad: ahorroUnidad,
      ahorro: ahorroUnidad * unidades,
      semanas: semanas, ultimaSemana: claves[0]
    };
  }

  var R = calcular();
  if (R) {
    var pon = function (sel, txt) { $$(sel).forEach(function (n) { n.textContent = txt; }); };
    pon('[data-rf-racha]', String(R.racha));
    pon('[data-rf-record]', String(R.record));
    pon('[data-rf-unidades]', String(R.unidades));
    pon('[data-rf-ahorro]', pesos(R.ahorro));
    pon('[data-rf-medio]', pesos(R.medio) + ' c/u');
    pon('[data-rf-fuera]', pesos(R.fuera));
    pon('[data-rf-ahorro-unidad]', pesos(R.ahorroUnidad));
    var faltan = Math.max(0, R.record - R.racha + 1);
    var meta = $('[data-rf-meta]');
    if (meta) {
      meta.textContent = R.racha >= R.record
        ? 'Estás en tu mejor racha. Sigue así.'
        : 'Te faltan ' + faltan + (faltan === 1 ? ' semana' : ' semanas') + ' para tu récord';
    }
    // Calendario de las últimas 8 semanas.
    var cal = $('[data-rf-semanas]');
    if (cal) {
      var hoy = semanaDe(Math.floor(Date.now() / 1000));
      var meses = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
      cal.innerHTML = '';
      for (var i = 7; i >= 0; i--) {
        var s = hoy - i;
        var on = !!R.semanas[s];
        var fecha = new Date((s * 604800 - 345600) * 1000);
        var div = document.createElement('div');
        div.className = 'rf-mc__sem' + (on ? ' is-on' : '');
        div.innerHTML = '<div class="rf-mc__sem-dot">' + (on
          ? '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0E3D0E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>'
          : '') + '</div><div class="rf-mc__sem-lab">' + (i % 2 === 0 ? meses[fecha.getMonth()] : '') + '</div>';
        cal.appendChild(div);
      }
    }
  }

  var bloqueRacha = $('[data-rf-bloque-racha]');
  if (bloqueRacha && !R) bloqueRacha.hidden = true;

  /* ============================================================
     5. PANELES POR HASH
     Las pantallas comparten una sola página de Shopify. Se usa el hash y no
     un parámetro porque Liquid NO puede leer la query string, y así el
     botón atrás y la paginación de pedidos (?page=2#pedidos) siguen
     funcionando sin JS de más.
     ============================================================ */
  var PANELES = ['inicio', 'pedidos', 'racha', 'kits', 'invita', 'datos'];

  function mostrar(nombre, moverScroll) {
    if (PANELES.indexOf(nombre) === -1) nombre = 'inicio';
    $$('[data-rf-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-rf-panel') !== nombre;
    });
    $$('[data-rf-nav]').forEach(function (a) {
      a.classList.toggle('is-on', a.getAttribute('data-rf-nav') === nombre);
    });
    // El saludo solo tiene sentido en Inicio.
    var saludo = $('.rf-mc__saludo');
    if (saludo) saludo.hidden = nombre !== 'inicio';
    if (moverScroll) {
      var y = raiz.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }
    evento('panel', { panel: nombre });
  }

  function delHash() { return (location.hash || '').replace('#', ''); }
  window.addEventListener('hashchange', function () { mostrar(delHash(), true); });
  mostrar(delHash(), false);

  /* ============================================================
     6. SECCIONES EN «PRÓXIMAMENTE»
     Cada sección tiene su interruptor en el editor de temas. Apagada, la fila
     sigue en el menú pero avisa en vez de abrir una pantalla vacía.
     ============================================================ */
  raiz.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-rf-pronto]');
    if (!b) return;
    ev.preventDefault();
    var nombre = b.getAttribute('data-rf-pronto') || 'Esta sección';
    aviso(nombre + ' está en camino. Te avisaremos en cuanto puedas usarla.', 'ok');
    evento('pronto', { seccion: nombre });
  });

  evento('ver', { pedidos: (D.pedidos || []).length });
})();

/* ============================================================
   7. VUELTA DEL ACCESO
   El botón «Entrar a mi cuenta» manda a Shopify con
   `return_to=/pages/mi-cuenta?desde=login`. Casi siempre volvemos con sesión y
   esto no hace nada. Pero Shopify sirve páginas desde su caché en la versión
   anónima, y en ese caso volveríamos a ver la pantalla de bienvenida estando
   dentro. Entonces se recarga UNA sola vez — con candado en sessionStorage para
   no entrar en bucle — y si aún así no hay sesión, se dice con palabras en vez
   de dejar al cliente dando vueltas.
   Va en su propio bloque porque no depende de nada del de arriba: solo mira si
   estamos viendo la pantalla de bienvenida y de dónde venimos.
   ============================================================ */
(function () {
  'use strict';
  var gate = document.querySelector('.rf-mc--gate');
  if (!gate) {
    try { sessionStorage.removeItem('rf_reintento_login'); } catch (e) {}
    return; // hay sesión: nada que recuperar
  }
  if (location.search.indexOf('desde=login') === -1) return;

  var YA = 'rf_reintento_login';
  var reintentado;
  try { reintentado = sessionStorage.getItem(YA) === '1'; } catch (e) { reintentado = true; }

  if (!reintentado) {
    try { sessionStorage.setItem(YA, '1'); } catch (e) {}
    location.replace('/pages/mi-cuenta');
    return;
  }
  var aviso = gate.querySelector('[data-rf-gate-aviso]');
  if (aviso) aviso.hidden = false;
})();
